export default __webpack_public_path__ + "static/media/phone_icon_laos.91d8e4ab.png";